module.exports = __webpack_public_path__ + "img/person.4251de13.jpg";